import './TableRowText.scss';

export interface ITableRowTextProps {
  isSupplementary?: boolean;
  text?: string;
  emptyText?: string;
  justifyPosition?: string;
  className?: string;
}

const TableRowText = ({
  isSupplementary = false,
  text,
  emptyText = '-',
  justifyPosition = 'start',
  className = '',
}: ITableRowTextProps) => {
  const itemText = text?.length ? text : emptyText;

  return (
    <div
      className={`table-row-item-text flex ${className} ${
        isSupplementary ? ' supplementary' : ''
      }`}
      title={itemText}>
      {itemText}
    </div>
  );
};

export default TableRowText;
